import React from 'react';
import {FaGift, FaPaw, FaUserFriends} from 'react-icons/fa';
import {appStoreLink, isMobileDevice} from '../../js/helpers/functions';
import '../OpenApp/styles.css';
import './styles.css';

class Invite extends React.Component {
	constructor(props) {
		super(props);
		this.fallbackTimer = null;
		this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
	}

	componentDidMount() {
		document.addEventListener('visibilitychange', this.handleVisibilityChange);
		if (isMobileDevice()) this.openApp();
	}

	componentWillUnmount() {
		this.clearFallback();
		document.removeEventListener('visibilitychange', this.handleVisibilityChange);
	}

	get code() {
		return String(this.props.match?.params?.code || '').replace(/[^A-Za-z0-9]/g, '').slice(0, 16);
	}

	openApp = () => {
		if (!isMobileDevice()) {
			appStoreLink();
			return;
		}
		window.location.href = `barkr://open/invite/${encodeURIComponent(this.code)}`;
		this.fallbackTimer = window.setTimeout(() => appStoreLink(), 1200);
	};

	handleVisibilityChange() {
		if (document.hidden) this.clearFallback();
	}

	clearFallback() {
		if (this.fallbackTimer) window.clearTimeout(this.fallbackTimer);
		this.fallbackTimer = null;
	}

	render() {
		return (
			<main className="open-app invite-page">
				<div className="open-app__card invite-card">
					<span className="open-app__icon"><FaGift/></span>
					<p className="open-app__eyebrow">YOUR FRIEND SENT YOU A GIFT</p>
					<h1>Meet your next favorite dog person.</h1>
					<p>Join Barkr, complete your dog profile, and you’ll both receive 7 days of Barkr Premium.</p>
					<div className="invite-benefits">
						<span><FaPaw/><strong>Discover nearby dogs</strong></span>
						<span><FaUserFriends/><strong>Plan real pawdates</strong></span>
					</div>
					<button type="button" onClick={this.openApp}>Open Barkr</button>
					<small>Already installed? This link opens your invite automatically.</small>
				</div>
			</main>
		);
	}
}

export default Invite;
